import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { UntilDestroy } from '@ngneat/until-destroy';
import { CSButtonComponent } from 'src/app/shared/components/cs-button/cs-button.component';
import { CSIconButtonComponent } from 'src/app/shared/components/cs-icon-button/cs-icon-button.component';
import { CSTabComponent } from 'src/app/shared/components/cs-tab/cs-tab.component';
import { DialogType, NotificationDialogService } from '../notification-dialog.service';
import { PipesModule } from 'src/app/shared/pipes/pipes.module';

@UntilDestroy()
@Component({
  selector: 'notification-detail-dialog',
  templateUrl: './detail.dialog.html',
  styleUrls: ['./detail.dialog.scss'],
  standalone: true,
  imports: [CSButtonComponent, CSIconButtonComponent, CSTabComponent, CommonModule, PipesModule],
})
export class NotificationDetailDialog {
  constructor(
    public service: NotificationDialogService,
    private dialogRef: MatDialogRef<NotificationDetailDialog>,
  ) {}

  public back() {
    this.service.dialogType$.next(DialogType.OVERVIEW);
  }

  public close() {
    this.service.reset();
    this.dialogRef.close();
  }
}
